const K = 1024;
const SIZES = ['Bytes', 'KB', 'MB', 'GB'];

export const formatBytes = (bytes = 0, decimals = 2): string => {
  if (Number.isNaN(bytes) || bytes < 1) return '0 Bytes';

  const i = Math.floor(Math.log(bytes) / Math.log(K));

  const size = (bytes / Math.pow(K, i)).toFixed(decimals);
  const unit = SIZES[i];

  return `${parseFloat(size)} ${unit}`;
};
